module.exports = __webpack_public_path__ + "static/media/brown-chairs.726fbbba.jpg";